import {AppController} from "../../../core/app/app-controller";
import {AppModuleState} from "../../../core/app/models/app-module.state";
import {FetchHandler} from "../../../infrastructure/handlers/fetch-handler";
import {EntityDescriptionDomainService} from "../../../domain/entity-description/services/entity-description.domain-service";
import {EntityDescriptionRequestParams} from "../../../domain/entity-description/models/entity-description.request-params";
import type {EntityDescriptionDataSource} from "../../../domain/entity-description/models/entity-description.data-source";
import {RouterController} from "../../../core/components/router/router-controller";
import {MetadataManager} from "../../../core/managers/metadata.manager";
import {WEBSITE_MODULE} from "../website-module.consts";

export class WebsiteModuleMetadataFetchHandler extends FetchHandler {
  controller: AppController;
  state: AppModuleState
  type = WEBSITE_MODULE.ACTION_TYPES.fetchMetadata

  static injectables = [EntityDescriptionDomainService, RouterController, MetadataManager];

  constructor(service: EntityDescriptionDomainService, routerController: RouterController, metadataManager: MetadataManager) {
    super(service);

    this.routerController = routerController
    this.metadataManager = metadataManager
  }

  async onLoaded() {}

  get requestParams() {
    const prefix = this.metadataManager.terminatorPrefix;
    const apiType = this.metadataManager.apiType;
    const entityId: Number = this.metadataManager.entityId;
    const entityType: Number = this.metadataManager.entityType;
    const sportType: Number = this.metadataManager.sportType;
    const sectionNames: String = this.metadataManager.sectionNames;

    const requestParams: EntityDescriptionRequestParams = new EntityDescriptionRequestParams(prefix, apiType, entityId, entityType, sportType, sectionNames, false);

    return requestParams;
  }

  async action() {
    const lastRequestParams = this.metadataManager?.lastRequestParams;

    if (!lastRequestParams || !this.requestParams.equals(lastRequestParams)) {
      const dataSource: EntityDescriptionDataSource = await super.fetch()
        .then((dataSource) => {
          this.metadataManager.lastRequestParams = dataSource?.request.params;
          this.metadataManager.updateSections(dataSource?.sections)
          return dataSource;
        });

      return dataSource
    }
  }
}
